import { isValidEmailAddress, isValidPassword, elementInViewport, QueryString, objectToUrlQuery, convertValuesToInt } from '../functions';
import Swal from 'sweetalert2';


$(document).ready(function() {

	$(document).on('click', '.group-show-info', function(e) {
		e.stopPropagation();
	});

	$(document).on('click', '.button_rezerva_form', function(e) {
		e.preventDefault();
		let url = $(this).data('url');
		let queryString = $(this).data('query-string');
		let group = $(this).data('group');

		window.location = url + '?' + queryString + '&group=' + group;
	});

	const groupsListing = {
        isLoading: false,
        init() {
            $(document).on('click', '.search-calendar-trigger', this, this.showCalendar);

			$(document).on('change', '.sort', function() {
				var parameters = QueryString(null);

				if ($(this).val() != '') {
					parameters.sort = $(this).val();
				} else {
					delete parameters.sort;
				}

				var url = objectToUrlQuery(parameters);

				window.location = selectCarRoute + (url != '' ? '?' + url : '');
			});
			
			$(document).on('change', '#from-time', function() {
				var parameters = QueryString(null);

				//$('#to-time').select2("val", $('#from-time option:selected').val());

				parameters.pd = $('#date-from').val() + '-' + $('#from-time option:selected').val();
				parameters.rd = $('#date-to').val() + '-' + $('#to-time option:selected').val();

				var url = objectToUrlQuery(parameters);

				window.location = selectCarRoute + (url != '' ? '?' + url : '');
			});

			$(document).on('change', '#to-time', function() {
				var parameters = QueryString(null);

				//$('#to-time').select2("val", $('#from-time option:selected').val());

				parameters.pd = $('#date-from').val() + '-' + $('#from-time option:selected').val();
				parameters.rd = $('#date-to').val() + '-' + $('#to-time option:selected').val();

				var url = objectToUrlQuery(parameters);

				window.location = selectCarRoute + (url != '' ? '?' + url : '');
			});

			$(document).on('change', '#pickup_location', function() {
				var parameters = QueryString(null);

				if ($('#pickup_location option:selected').val() != '') {
					parameters.pl = $('#pickup_location option:selected').val();
				} else {
					delete parameters.pl;
				}

				var url = objectToUrlQuery(parameters);

				window.location = selectCarRoute + (url != '' ? '?' + url : '');
			});

			$(document).on('change', '#return_location', function() {
				var parameters = QueryString(null);

				if ($('#return_location option:selected').val() != '') {
					parameters.rl = $('#return_location option:selected').val();
				} else {
					delete parameters.rl;
				}

				var url = objectToUrlQuery(parameters);

				window.location = selectCarRoute + (url != '' ? '?' + url : '');
			});

			$(document).on('change', '#vehicle_class', function() {
				var parameters = QueryString(null);

				if ($('#vehicle_class option:selected').val() != '') {
					parameters.vc = $('#vehicle_class option:selected').val();
				} else {
					delete parameters.vc;
				}

				var url = objectToUrlQuery(parameters);
				console.log(url);
				window.location = selectCarRoute + (url != '' ? '?' + url : '');
			});

			$(document).on('change', '#transmission', function() {
				var parameters = QueryString(null);

				if ($('#transmission option:selected').val() != '') {
					parameters.t = $('#transmission option:selected').val();
				} else {
					delete parameters.t;
				}

				var url = objectToUrlQuery(parameters);

				window.location = selectCarRoute + (url != '' ? '?' + url : '');
			});

			$(document).on('change', '#fuel', function() {
				var parameters = QueryString(null);

				parameters.f = $('#fuel option:selected').val();

				var url = objectToUrlQuery(parameters);

				window.location = selectCarRoute + (url != '' ? '?' + url : '');
			});

			$(document).on('click', '.passengers', function() {
				let parameters = QueryString(null);
				let id = $(this).data('value');
				id = parseInt(id);

				let passengers = [];
				if(parameters.p) {
					passengers = parameters.p.split(',');
					passengers = convertValuesToInt(passengers);
				}

				let index = passengers.indexOf(id);
				if(index === -1) {
					passengers.push(id);
				} else {
					passengers.splice(index, 1);
				}

				if (passengers.length > 0) {
					parameters.p = passengers.join(',');
				} else {
					delete parameters.p;
				}

				var url = objectToUrlQuery(parameters);
				window.location = selectCarRoute + (url != '' ? '?' + url : '');
			});

			$(document).on('click', '.doors', function() {
				let parameters = QueryString(null);
				let id = $(this).data('value');
				id = parseInt(id);

				let doors = [];
				if(parameters.d) {
					doors = parameters.d.split(',');
					doors = convertValuesToInt(doors);
				}

				let index = doors.indexOf(id);
				if(index == -1) {
					doors.push(id);
				} else {
					doors.splice(index, 1);
				}

				if (doors.length > 0) {
					parameters.d = doors.join(',');
				} else {
					delete parameters.d;
				}

				var url = objectToUrlQuery(parameters);
				window.location = selectCarRoute + (url != '' ? '?' + url : '');
			});
        },
		showCalendar(event) {
			const _this = event.data;
			event.preventDefault();

			var type = $(this).data('type')
			var days = $(this).data('days')
			var element = this;

			var date = moment($('#date-from').val(), 'DD/MM/YYYY')
			if (type == 1) {
				date = moment($('#date-to').val(), 'DD/MM/YYYY')
			}

			$('#modal-calendar').modal('show');
			$('#modal-calendar').on('shown.bs.modal', function (e) {
				// $('#calendar-wrapper').removeClass('visually-hidden');
				// $('.daterangepicker').css("display", "block");

				$('#calendar-place').daterangepicker({
					alwaysShowCalendars: true,
					minDate: moment().add(2, 'hours'),
					startDate: date,
					//minDate: moment().add(1, 'days'),
					// startDate: moment().add(1, 'days'),
					// endDate: moment().add(3, 'days'),
					autoApply: true,
					autoUpdateInput: false,
					singleDatePicker: true,
					locale: {
						format: 'DD/MM/YYYY'
					}
				});

				$('#calendar-place').on('apply.daterangepicker', function(ev, picker) {
					var startDate = picker.startDate;
					//var endDate = picker.endDate;

					$(element).html(startDate.format('DD/MM/YYYY'));

					if (type == 0) {
						$('#date-from').val(startDate.format('DD/MM/YYYY'));
						var toDate = startDate.add(days, 'days');
						$('#date-to').val(toDate.format('DD/MM/YYYY'));
						$('.date-to-btn').text(toDate.format('DD/MM/YYYY'));
					} else {
						$('#date-to').val(startDate.format('DD/MM/YYYY'));
					}

					$('#modal-calendar').modal('hide');

					let parameters = QueryString(null);

					parameters.pd = $('#date-from').val() + '-' + $('#from-time option:selected').val();
					parameters.rd = $('#date-to').val() + '-' + $('#to-time option:selected').val();

					var url = objectToUrlQuery(parameters);
					window.location = selectCarRoute + (url != '' ? '?' + url : '');
				});
			});
		},
    };

    if ($('.groups-listing-container').length) {
        groupsListing.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/groups.js